'use client';

import {
  type EdgeProps,
  type Edge,
  type Node,
  useReactFlow,
} from '@xyflow/react';
import type { AiFlowCustomNodeProps } from './AiFlowCustomNode';
import { getAiFlowNodeColor } from './utils';
import { GradientEdge } from '../flow-graph-base/GradientEdge';

type AiFlowNode = Node<AiFlowCustomNodeProps>;

const FALLBACK_COLOR = 'var(--colors-lilac-8)';

export function AiFlowCustomEdge(props: EdgeProps) {
  const { getNode } = useReactFlow<AiFlowNode, Edge>();
  const sourceNode = getNode(props.source);
  const targetNode = getNode(props.target);

  const sourceColor = sourceNode
    ? getAiFlowNodeColor(sourceNode.data.type)
    : FALLBACK_COLOR;
  const targetColor = targetNode
    ? getAiFlowNodeColor(targetNode.data.type)
    : FALLBACK_COLOR;

  return (
    <GradientEdge
      {...props}
      sourceColor={sourceColor}
      targetColor={targetColor}
      labelHeight={60}
      labelMaxLines={3}
    />
  );
}
